// Time constraints (HRS-2640): decoupled from the custom-route planner grid.
// Routes can start from 07:00; when the user does not touch the field the
// route starts at 10:00.
export const MIN_TIME = '07:00' as const;
export const MAX_TIME = '23:00' as const;
export const DEFAULT_TIME = '10:00' as const;
